import React from "react";
import InfoMessageComponent from "@components-shared/InfoMessageComponent";

export function EmptyContent(props: { message: string; emptyIcon?: string }) {
	const { message, emptyIcon } = props;

	return (
		<div className="event__section">
			<InfoMessageComponent
				type="empty"
				message={message}
				emptyIcon={emptyIcon || "u-icon--empty--bets"}
				addClassName="u-mar--bottom--reset"
			/>
		</div>
	);
}
